import { useDispatch } from 'react-redux';

import { logOut } from 'actions/authentication';
import Icon from 'atoms/icon';
import { openDrawer } from 'store/reducers/ui';

import ProviderTitle from './ProviderTitle';

const profileDrawers = {
  information: 'provider-information',
  hours: 'provider-hours',
  services: 'provider-services',
  team: 'provider-team',
};

export default function MobileProfile({ isMyProvider, provider }) {
  const dispatch = useDispatch();
  const { locations } = provider;
  const location = locations[0];
  const { hours, services } = location;

  const handleItemClick = (item) => {
    const drawerName = profileDrawers[item];
    if (drawerName && location)
      dispatch(
        openDrawer({ type: drawerName, data: { hours, location, services } })
      );
  };

  if (!provider) return null;

  return (
    <div className="mobile-profile flex-column">
      <h1 className="f28 mb-32">Profile</h1>
      <ProviderTitle isMyProvider={isMyProvider} provider={provider} />
      <button
        className="profile-item no-style-btn"
        onClick={() => handleItemClick('information')}
      >
        <p>Contact information</p>
        {location && <Icon name="chevronRight" />}
      </button>
      <button
        className="profile-item no-style-btn"
        onClick={() => handleItemClick('hours')}
      >
        <p>Hours</p>
        {location && <Icon name="chevronRight" />}
      </button>
      <button
        className="profile-item no-style-btn"
        onClick={() => handleItemClick('services')}
      >
        <p>Services</p>
        {location && <Icon name="chevronRight" />}
      </button>
      <button
        className="profile-item no-style-btn"
        onClick={() => handleItemClick('team')}
      >
        <p>Team</p>
        {location && <Icon name="chevronRight" />}
      </button>
      <button className="profile-item no-style-btn" onClick={() => logOut('/')}>
        <p className="c-primary-purple">Logout</p>
      </button>
    </div>
  );
}
